import VueRouter from "vue-router";
import Vue from "vue";
import routes from "./routes";
import MainStore from "../stores/MainStore";


const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior: function() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  
  /********** handle background class **********/
  //remove previous classess
  document.body.className = "";
  // add the path class to body for spinner color
  document.body.classList.add(to.fullPath.replace("/", ""));

  /********** handle newsboard browser back **********/
  if (MainStore.state.NewsListShow) {
    MainStore.commit("ToggleNewBoardStatus", false);
    next(from);
    return;
  }

  next();
});

Vue.use(VueRouter);

export default router;
